(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_781afe1"] && !Shopify.designMode) return;
  try {
    if (!window.euLegalGuaranteeInitialized) {
    window.euLegalGuaranteeInitialized = true;

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-eu-guarantee-open]');

      if (opener) {
        const dialog = document.getElementById(
          opener.getAttribute('aria-controls')
        );

        if (dialog) {
          event.preventDefault();
          dialog.showModal();
        }

        return;
      }

      const closer = event.target.closest('[data-eu-guarantee-close]');

      if (closer) {
        const dialog = closer.closest('dialog');

        if (dialog) {
          dialog.close();
        }
      }
    });

    document.addEventListener('click', (event) => {
      if (event.target.matches('dialog.eu-guarantee__dialog')) {
        event.target.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["piq-article-meta"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('piq-article-meta')) {
    customElements.define(
      'piq-article-meta',
      class extends HTMLElement {
        connectedCallback() {
          const toc = this.querySelector('.piq-am__toc');
          const list = this.querySelector('[data-toc-list]');
          if (!toc || !list) return;
          const scope = this.closest('.section') || document;
          const heads = Array.from(scope.querySelectorAll('.blog-post-content h2, .rte h2')).filter((h) => h.textContent.trim());
          if (heads.length < 3) return;
          heads.forEach((h, i) => {
            if (!h.id) h.id = 'abschnitt-' + (i + 1);
            h.style.scrollMarginTop = '100px';
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.href = '#' + h.id;
            a.textContent = h.textContent.trim();
            li.appendChild(a);
            list.appendChild(li);
          });
          toc.hidden = false;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["piq-product-upsell"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const b = e.target.closest('.piq-pu__add[data-variant]');
    if (!b || !window.piqAddToCart) return;
    const root = b.closest('.piq-pu');
    b.disabled = true;
    b.textContent = '…';
    window
      .piqAddToCart([{ id: parseInt(b.dataset.variant, 10), quantity: 1 }], {
        addUrl: root.dataset.addUrl,
        cartUrl: root.dataset.cartUrl
      })
      .then(() => {
        b.textContent = '✓';
        setTimeout(() => {
          b.textContent = '+';
          b.disabled = false;
        }, 1600);
      })
      .catch((err) => {
        console.error(err);
        b.textContent = '+';
        b.disabled = false;
      });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["piq-sticky-cta"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('piq-sticky-cta')) {
    customElements.define(
      'piq-sticky-cta',
      class extends HTMLElement {
        connectedCallback() {
          try {
            if (sessionStorage.getItem('piq-sticky-closed')) return;
          } catch (e) {}
          this.hidden = false;
          this.blockers = new Set();

          // Nicht zeigen, solange CTA-Karte, Produkte, Newsletter oder Footer sichtbar sind
          this.io = new IntersectionObserver((entries) => {
            entries.forEach((en) => (en.isIntersecting ? this.blockers.add(en.target) : this.blockers.delete(en.target)));
            this.update();
          });
          document
            .querySelectorAll('.piq-acta--card, .piq-ap, .shopify-section-group-footer-group, footer, [id*="newsletter"]')
            .forEach((el) => this.io.observe(el));

          this.onScroll = () => this.update();
          window.addEventListener('scroll', this.onScroll, { passive: true });
          document.addEventListener('focusin', this.onScroll);
          document.addEventListener('focusout', this.onScroll);

          this.querySelector('[data-close]').addEventListener('click', () => {
            this.closed = true;
            this.update();
            try {
              sessionStorage.setItem('piq-sticky-closed', '1');
            } catch (e) {}
          });
        }

        update() {
          const max = document.documentElement.scrollHeight - window.innerHeight;
          const ratio = max > 0 ? window.scrollY / max : 0;
          const overlayOpen = !!document.querySelector('dialog[open], theme-drawer[open], .is-open[role="dialog"]');
          const typing = document.activeElement && /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName);
          const show = !this.closed && ratio > 0.2 && this.blockers.size === 0 && !overlayOpen && !typing;
          if (show === this.visible) return;
          this.visible = show;
          this.classList.toggle('is-visible', show);
          // Platz unten reservieren, damit nichts verdeckt wird
          document.body.style.paddingBottom = show ? this.offsetHeight + 20 + 'px' : '';
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          document.removeEventListener('focusin', this.onScroll);
          document.removeEventListener('focusout', this.onScroll);
          if (this.io) this.io.disconnect();
          document.body.style.paddingBottom = '';
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
